// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contract-number h1 {\n  margin-left: 0px !important;\n}", "",{"version":3,"sources":["webpack://./src/app/cp/construction/contracts/jobs/contract-jobs.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;AAAR","sourcesContent":[".contract-number{\n    h1{\n        margin-left:0px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
